import { useEffect } from 'react';

const useChatMode = ({ chatMode, newMessageText, inputRef, isCursorBetweenBrackets, setChatMode }) => {
  useEffect(() => {
    if (!inputRef?.current) return;

    const prevCaretPosition = inputRef.current.selectionStart;
    inputRef.current.focus();

    if (chatMode === 'brackets' && newMessageText.includes(' []')) {
      inputRef.current.setSelectionRange(newMessageText.length - 1, newMessageText.length - 1);
    } else if (chatMode === 'chat') {
      inputRef.current.setSelectionRange(prevCaretPosition, prevCaretPosition);
    }
  }, [chatMode, newMessageText, inputRef]);

};

export default useChatMode;
